import styled, { css } from 'styled-components';
import { ifElse, propEq, prop } from 'ramda';
import { fonts } from '../../../theme/styled';
import {
  ICON_ARROW_LEFT,
  ICON_ARROW_RIGHT,
  ICON_BOOK,
  ICON_CALENDAR,
  ICON_CROSS,
  ICON_DOTS,
  ICON_DOWN,
  ICON_MEAL,
  ICON_MINUS,
  ICON_PLUS,
  ICON_TIME,
  ICON_TRANSPORT,
  ICON_UP,
  ICON_WISHLIST,
  ICON_WINNOW_LOGO,
  ICON_CODE,
  ICON_INFO,
  ICON_PEOPLE,
  ICON_LOCATION,
} from './icon.constants';
import { renderWhenTrue } from '../../utils/rendering';
import { themeColor } from '../../../theme/getters';

const iconContentMap = {
  [ICON_CALENDAR]: '900',
  [ICON_BOOK]: '902',
  [ICON_MEAL]: '903',
  [ICON_TRANSPORT]: '904',
  [ICON_CROSS]: '905',
  [ICON_DOTS]: '906',
  [ICON_DOWN]: '907',
  [ICON_MINUS]: '908',
  [ICON_PLUS]: '909',
  [ICON_INFO]: '910',
  [ICON_LOCATION]: '911',
  [ICON_PEOPLE]: '912',
  [ICON_TIME]: '90a',
  [ICON_UP]: '90b',
  [ICON_WISHLIST]: '90c',
  [ICON_ARROW_RIGHT]: '90d',
  [ICON_ARROW_LEFT]: '901',
  [ICON_WINNOW_LOGO]: '90e',
  [ICON_CODE]: '90f',
};

const getIconSize = ({ stroked, size }) => (stroked ? size * 0.4 : size);

const themeMainColor = ifElse(propEq('inactive', true), themeColor('border'), themeColor('primary'));

const themeBorderColor = ifElse(propEq('inactive', true), themeColor('disabled'), themeColor('border'));

const propOrThemeGetter = (propName, getter) => props => props[propName] || getter(props);

const getStrokedStyles = ({ stroked, size }) =>
  renderWhenTrue(
    () => css`
      width: ${size}px;
      height: ${size}px;
      border: 1px solid ${propOrThemeGetter('borderColor', themeBorderColor)};
      border-radius: 50%;
      line-height: ${prop('size')}px;
      box-sizing: border-box;

      &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `
  )(stroked);

export const Glyph = styled.i`
  position: relative;
  font-family: "${fonts.icon}" !important;
  display: block;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  vertical-align: middle;
  text-align: center;
  border: 0;
  font-size: ${getIconSize}px;
  line-height: ${getIconSize}px;
  ${getStrokedStyles};
  color: ${propOrThemeGetter('color', themeMainColor)};

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  &:before {
    content: "\\e${({ name }) => iconContentMap[name]}";
  }
`;
